import { createFileRoute } from "@tanstack/react-router";
import { useApp } from "@/context/AppContext";
import { Approvals } from "@/pages/client/Approvals";
import { FeedbackEingang } from "@/pages/team/FeedbackEingang";

/**
 * Eine Adresse, zwei Sichten (wie `/projekte`): Das Team sieht hier seinen
 * Eingang „Feedback & Wartendes", ein Kundenkonto seine Freigaben.
 */
export const Route = createFileRoute("/_angemeldet/freigaben")({
	component: FreigabenSeite,
});

function FreigabenSeite() {
	const { role } = useApp();
	return role === "mitarbeiter" ? <FeedbackEingang /> : <Approvals />;
}
